<template>
    <v-tab-item :value="$route.path" class="pa-3">
        <v-toolbar flat height="80">
            <v-spacer></v-spacer>

            <v-col cols="12" sm="3">
                <v-menu
                    :close-on-content-click="true"
                    offset-y
                    max-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            :label="translations.date[lang]"
                            class="mr-4"
                            color="secondary"
                            autocomplete="off"
                            hint="YYYY/DD format"
                            rounded
                            outlined
                            dense
                            clearable
                            hide-details
                            :prepend-inner-icon="icons.mdiCalendarSearch"
                            v-on="on"
                            v-model="date"
                        ></v-text-field>
                    </template>

                    <v-date-picker
                        v-model="date"
                        color="secondary"
                        type="month"
                        no-title
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-toolbar>
        <v-row v-if="loading" no-gutters justify="center" align="center">
            <v-progress-circular indeterminate></v-progress-circular>
        </v-row>
        <div v-if="!loading">
            <v-row v-for="(item, index) in smsMetrics" :key="index">
                <v-col cols="6">
                    <span class="font-weight-bold"
                        >{{ translations.notificationType[lang] }}:</span
                    >
                    {{ item.notification_category_name }}
                </v-col>
                <v-col cols="6">
                    <span class="font-weight-bold"
                        >{{ translations.total[lang] }}:</span
                    >
                    {{ item.total }}
                </v-col>
            </v-row>
        </div>
        <v-row
            v-if="smsMetrics.length === 0 && !loading"
            no-gutters
            justify="center"
            align="center"
        >
            No Data
        </v-row>
    </v-tab-item>
</template>

<script>
import { mdiCalendarSearch } from "@mdi/js";
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/branchDebt/smsMetrics";
import moment from "moment";

export default {
    name: "SMSMetrics",

    mixins: [translations],

    data() {
        return {
            icons: { mdiCalendarSearch },
            date: "",
        };
    },

    computed: {
        ...mapState(["loading", "errorMessage", "serverItemsLength"]),
        ...mapState("loyaltyPanel/branchDebt", ["smsMetrics"]),

        lang() {
            return this.$route.params.lang;
        },
    },

    methods: {
        ...mapActions("loyaltyPanel/branchDebt", ["getSmsMetrics"]),
    },

    watch: {
        date(val) {
            this.getSmsMetrics(val);
        },
    },

    mounted() {
        this.date = moment().subtract(1, "months").format("YYYY-MM");
    },
};
</script>
